export default __webpack_public_path__ + "static/media/Slider-2.0337f4f0.png";